/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerRightDownIcon64Regular = forwardRef('ArrowDCornerRightDownIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M41 20.5a9.5 9.5 0 0 0-9.5-9.5h-24a1.5 1.5 0 0 0 0 3h24a6.5 6.5 0 0 1 6.5 6.5v31.11a2.526 2.526 0 0 1-.268-.232L22.794 36.439a1.5 1.5 0 0 0-2.122 2.122l14.939 14.938a5.5 5.5 0 0 0 7.778 0l14.939-14.938a1.5 1.5 0 1 0-2.122-2.122L41.268 51.378a2.52 2.52 0 0 1-.268.233V20.5Z" })));
});
